<template>
  <v-app>
      
    <v-main class="main-content">
      <!-- Contenedor principal -->
      <v-row justify="center" align="center" class="fill-height">
        <v-col cols="12" sm="8" md="6" lg="4">
          <v-card class="mx-auto" max-width="400">
            <!-- Imagen -->
            <v-img
              class="align-end text-white"
              height="200"
              cover
              src="https:///images/publicidad/productos.jpg"
            />
            
            <!-- Selector de Facturas -->
            <v-card-subtitle class="pt-4">
              <v-select
                v-model="facturaSeleccionada"
                :items="facturasFiltradas"
                item-title="nombre"
                item-value="id"
                label="Selecciona una factura"
                @change="descargarFactura"
              />
            </v-card-subtitle>

            <!-- Botones -->
            <v-card-actions class="d-flex justify-center">
              <button
                @click="dialog = true"
                class="bg-green-500 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded-lg shadow-md transition duration-300"
              >
                Filtrar por fecha
              </button>
              <button
                @click="descargarFactura"
                class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                Descargar Factura
              </button>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <!-- Diálogo para filtrar por fecha -->
      <v-dialog v-model="dialog" max-width="500px" scrollable>
        <v-card>
          <v-card-title>
            <span class="text-h5">Filtrar por Fechas</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <label for="fechaInicio">Fecha de Inicio:</label>
                <input
                  type="date"
                  id="fechaInicio"
                  v-model="fechaInicio"
                  @change="filtrarFacturas"
                  class="input-date"
                />
              </v-col>
              <v-col cols="12">
                <label for="fechaFin">Fecha de Fin:</label>
                <input
                  type="date"
                  id="fechaFin"
                  v-model="fechaFin"
                  @change="filtrarFacturas"
                  class="input-date"
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-btn color="primary" @click="aplicarFiltro">Aplicar</v-btn>
            <v-btn text @click="dialog = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-main>
  </v-app>
</template>


<script>
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import QRCode from 'qrcode';

export default {
  components: {  },
  data() {
    return {
      dialog: false, // Controla si el dialog está visible o no
      facturaSeleccionada: null,
      fechaInicio: null,
      fechaFin: null,
      facturasDisponibles: [
        { id: 'PDTG FRFAC_DOCUMENTO/AA-896', nombre: 'Factura PDTG 113046', tipo: 'PDF', fecha: '2025-03-26' },
        { id: 'PDTG FRFAC_DOCUMENTO/AA-897', nombre: 'Factura PDTG 113047', tipo: 'XML', fecha: '2025-03-26' },
        { id: 'PDTG FRFAC_DOCUMENTO/AA-898', nombre: 'Factura PDTG 113048', tipo: 'PDF', fecha: '2025-03-26' },
      ],
      facturasFiltradas: [],
    };
  },
  methods: {

    aplicarFiltro() {
      let facturasFiltradas = this.facturasDisponibles;

      if (this.fechaInicio) {
        facturasFiltradas = facturasFiltradas.filter(factura => factura.fecha >= this.formatDate(this.fechaInicio));
      }

      if (this.fechaFin) {
        facturasFiltradas = facturasFiltradas.filter(factura => factura.fecha <= this.formatDate(this.fechaFin));
      }

      this.facturasFiltradas = facturasFiltradas;

      // Cerrar el diálogo después de aplicar el filtro
      this.dialog = false;
    },
    filtrarFacturas() {
      let facturasFiltradas = this.facturasDisponibles;

      if (this.fechaInicio) {
        facturasFiltradas = facturasFiltradas.filter(factura => factura.fecha >= this.formatDate(this.fechaInicio));
      }

      if (this.fechaFin) {
        facturasFiltradas = facturasFiltradas.filter(factura => factura.fecha <= this.formatDate(this.fechaFin));
      }

      this.facturasFiltradas = facturasFiltradas;
    },

    formatDate(date) {
      if (!date) return null;

      // Si la fecha ya es un string, conviértela a un objeto Date
      const parsedDate = new Date(date);

      if (isNaN(parsedDate)) return null; // Verifica si es una fecha válida

      return parsedDate.toISOString().split('T')[0]; // Retorna en formato YYYY-MM-DD
    },
    customFormat(date) {
      if (!date) return '';
      return new Intl.DateTimeFormat('es-ES', { dateStyle: 'medium' }).format(date);
    },

    descargarFactura() {
      const factura = this.facturasFiltradas.find(f => f.id === this.facturaSeleccionada);
      if (!factura) return;

      if (factura.tipo === 'PDF') {
        this.downloadPDF();
      } else if (factura.tipo === 'XML') {
        this.downloadXML();
      }
    },

    async downloadPDF() {
      const doc = new jsPDF();
      doc.setFontSize(18);
      doc.text('Distribuidora de Refrescos Paral', 20, 20);
      doc.setFontSize(14);
      doc.text(`Factura No: ${this.facturaSeleccionada}`, 20, 30);
      doc.text('RFC Emisor: XAXX010101000', 20, 40);
      doc.text('Total: $58,000.00', 20, 50);
      doc.text('Fecha Emisión: 26/03/2025 06:21:41 p. m.', 20, 60);
      doc.text('Fecha Timbrado: 26/03/2025 06:21:42 p. m.', 20, 70);

      const qrCode = await QRCode.toDataURL(this.facturaSeleccionada);
      doc.addImage(qrCode, 'PNG', 150, 20, 40, 40);

      doc.save(`Factura_${this.facturaSeleccionada}.pdf`);
    },

    downloadXML() {
      const xml = `<?xml version="1.0" encoding="UTF-8"?>
      <Factura>
        <Emisor>
          <Rfc>XAXX010101000</Rfc>
          <Nombre>Distribuidora de Refrescos Paral</Nombre>
        </Emisor>
        <UUID>${this.facturaSeleccionada}</UUID>
        <Total>$58,000.00</Total>
      </Factura>`;

      const blob = new Blob([xml], { type: 'application/xml' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `Factura_${this.facturaSeleccionada}.xml`;
      link.click();
    }
  },
  created() {
    this.facturasFiltradas = this.facturasDisponibles; // Inicialmente mostrar todas las facturas
  }
};
</script>
<style>
.input-date {
  width: 100%;
  padding: 8px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
  outline: none;
}

.input-date:focus {
  border-color: #4CAF50;
  box-shadow: 0 0 5px rgba(76, 175, 80, 0.5);
}

.main-content {
  padding-bottom: 80px;
  background-size: cover;
  /* Asegura que la imagen cubra todo el fondo */
  background-position: center;
  /* Centra la imagen en el contenedor */
  background-repeat: no-repeat;
  /* Evita que la imagen se repita */
}

</style>